import { FieldValues, Path, useFormContext } from "react-hook-form";

export const useIsFormValueSet = <TValues extends FieldValues>(
  path: Path<TValues>
) => {
  const { getValues } = useFormContext<TValues>();

  return !!getValues(path);
};
